
export enum DumpsterStatus {
  Error = "Error",
  Warning = "Warning"
}
